import {get} from 'packages/rest/api';
import {SessionRuntime} from '../model';

export async function LoadSessionAPI() {
    return await get({url: 'session'}, SessionRuntime);
}
